import * as CONST from "./actionTypes";

const intialState = {
  serviceListData: [],
  serviceDataById: null,
  total: 0,
  loading: false,
};

const serviceReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    //get data
    case CONST.GET_SERVICES:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_SERVICES_SUCCESS:
      return {
        ...state,
        serviceListData: payload?.data,
        total: payload.totalcount,
        loading: false,
      };

    case CONST.GET_SERVICES_FAIL:
      return {
        ...state,
        loading: false,
      };
    case CONST.UPDATE_SERVICES_LIST:
      return {
        ...state,
        serviceListData: payload,
      };

    // get service by id
    case CONST.GET_SERVICES_BY_ID:
      return {
        ...state,
      };

    case CONST.GET_SERVICES_BY_ID_SUCCESS:
      return {
        ...state,
        serviceDataById: payload,
      };

    case CONST.GET_SERVICES_BY_ID_FAIL:
      return {
        ...state,
      };

    // remove

    case CONST.REMOVE_SERVICE:
      return {
        ...state,
      };

    case CONST.REMOVE_SERVICE_SUCCESS:
      return {
        ...state,
      };
    case CONST.REMOVE_SERVICE_FAIL:
      return {
        ...state,
      };

    default:
      return state;

      break;
  }
};

export default serviceReducer;
